document.addEventListener("DOMContentLoaded", () => {
  const deadline = "2024/12/15 15:00";
  const containers = document.querySelectorAll(".themilfos-container");
  const addToCarts = document.querySelectorAll(".add-to-cart-milfo");

  const collectionItems = document.querySelectorAll(".collection-item-99");

  const grid = document.querySelector(".themilfos-grid");
  let cardClickEnabled = true;
  const textLimit = 91;
  let fileuploaded = false;

  const defaultImageURL = "https://cdn.shopify.com/s/files/1/0272/1644/5553/files/milfo-plastico-roto_248cf51e-06f1-4f12-86bf-d6b60e894d7f.png?v=1730385113";

  containers.forEach((container, index) => {
    if ([0, 6, 7, 8, 60].includes(index)) {
      return;
    }
    const cards = container.querySelectorAll(".themilfos-card");
    const userTest = container.querySelector(".user-test-section");
    const dropArea = userTest.querySelector(".drop-area");
    const fileInput = userTest.querySelector(".file-elem");
    const imageList = userTest.querySelector(".image-list");
    const textArea = userTest.querySelector(".custom-textarea");
    const backgroundPopup = container.querySelector(".background-popup-test");
    const closeButton = userTest.querySelectorAll(".close-button");


    cards.forEach((card, index) => {
      const cardContentText = card.querySelector(".themilfos-card__content");
      const button = card.querySelector(".button-test-user");
      const tryButton = userTest.querySelectorAll(".watch-product-button");
      const charCounter = userTest.querySelector(".char-counter");
      const productSectionCard = document.querySelector(
        ".container-product-milfo"
      );
      const buttonSection = document.querySelector(
        ".product-back-milfo"
      );
      const productSectionMilfo = document.querySelector(
        ".product-section-milfo"
      );

      const addToCartMilfo = document.querySelector(".add-to-cart-milfo");


      card.addEventListener("click", () => {

        const index = card.id;

        cards.forEach((otherCard) => {
          if (otherCard !== card) {
            gsap.to(otherCard, {
              opacity: 0,
              duration: 0.5,
              onComplete: () => (otherCard.style.display = "none"),
            });
          }
        });

        if (cardClickEnabled) {
          productSectionCard.scrollTop = 0;
          gsap.set(productSectionMilfo, {
            opacity: 0,
          });

          gsap.set(productSectionCard, {
            position: "absolute",
            zIndex: 5,
            display: "flex",
          });



          gsap.set(grid, {
            display: "none",
          });

          addToCarts[index - 1].style.display = "block";
          collectionItems[index - 1].style.display = "block";

          let timeline = gsap.timeline();
          let originalCardPosition = card.getBoundingClientRect().top;
          let scrollY = window.scrollY + originalCardPosition;

          timeline.to(productSectionMilfo, {
            opacity: 1,
            duration: 0.5,
          });

          timeline.to(addToCartMilfo, {
            display: "block",
            duration: 0.5,
          });


          timeline.to(productSectionCard, {
            opacity: 1,
            ease: "power1.inOut",
          });

          addToCarts[index - 1].style.display = "block";
          collectionItems[index - 1].style.display = "block";

          document.body.style.overflow = "auto";
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // Desplazamiento suave
            });
          }, 100);

          buttonSection.addEventListener("click", () => {
            let reverseProductTimeline = gsap.timeline();

            reverseProductTimeline.to(grid, {
              display: "grid",
              duration: 0.5,
            });

            reverseProductTimeline.to(productSectionCard, {
              duration: 0.5,
              opacity: 0,
              ease: "power1.inOut",
            });

            reverseProductTimeline.to(productSectionMilfo, {
              opacity: 0,
              duration: 0.5,
            });

            reverseProductTimeline.add(() => {
              productSectionCard.style.display = "none";
              if (addToCarts[index - 1]) {
                addToCarts[index - 1].style.display = "none";
              }
              addToCarts[index - 1].style.display = "none";
              if (collectionItems[index - 1]) {
                collectionItems[index - 1].style.display = "none";
              }
              collectionItems[index - 1].style.display = "none";
            });

            setTimeout(() => {
              window.scrollTo({
                top: scrollY,
                behavior: 'smooth' // Desplazamiento suave
              });
            }, 1000);


          });
        }
      });
    });
  });
});

